<span class="flex items-end" @fadeIn>
    <span class="mr-5 -mb-px font-sans text-sm font-bold leading-none uppercase text-simon-gray">Powered by</span>
    <img src="assets/images/simon-text.svg" alt="" class="w-auto h-18">
</span>     